import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@reenstudio/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PeakChartApiService {
  params: any = {};
  apiUrl = environment.api;
  apiHeaders = environment.apiHeaders;

  constructor(private http: HttpClient) {}

  getPeak(cer: number, site: number, start: Date, end: Date): Observable<any> {
    const apiUrl = `${this.apiUrl}/historic/peak`;

    const formattedStartDateTime = this.formatDateTime(start);
    const formattedEndDateTime = this.formatDateTime(end);

    this.params.start = formattedStartDateTime;
    this.params.end = formattedEndDateTime;
    this.params.site_id = site;
    this.params.cer_id = cer;

    return this.http.get(apiUrl, {
      headers: this.apiHeaders,
      params: this.params,
    });
  }

  formatDateTime(dateTime: Date, type: string = ''): string {
    if (type === 'end') {
      let stringDate = dateTime.toISOString().slice(0, 19).replace('T', ' ');
      const nuovoOrario = '23:59:59';
      let timestampString = stringDate.replace(
        /\d{2}:\d{2}:\d{2}/,
        nuovoOrario
      );
      return timestampString;
    } else if (type === 'start') {
      let stringDate = dateTime.toISOString().slice(0, 19).replace('T', ' ');
      const nuovoOrario = '00:00:01';
      let timestampString = stringDate.replace(
        /\d{2}:\d{2}:\d{2}/,
        nuovoOrario
      );
      return timestampString;
    }
    return dateTime.toISOString().slice(0, 19).replace('T', ' ');
  }
}
